// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/ai_seo_writing.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/ai_seo_writing.proto.
 */
export const file_api_proto_v1_ai_seo_writing: GenFile = /*@__PURE__*/
  fileDesc("CiFhcGlfcHJvdG8vdjEvYWlfc2VvX3dyaXRpbmcucHJvdG8SDGFwaV9wcm90by52MSKMAQoZR2VuZXJhdGVTZW9BcnRpY2xlUmVxdWVzdBIPCgdrZXl3b3JkGAEgASgJEhIKCndvcmRfY291bnQYAiABKAkSFgoOcmVmZXJlbmNlX3VybHMYAyADKAkSHAoUaW50ZXJuYWxfbGlua19kb21haW4YBCABKAkSFAoMaW5zdHJ1Y3Rpb25zGAUgASgJImEKF1JldmlzZVNlb0FydGljbGVSZXF1ZXN0EikKB2N1cnJlbnQYASABKAsyGC5hcGlfcHJvdG8udjEuU2VvQXJ0aWNsZRIbChNyZXZpc2VfaW5zdHJ1Y3Rpb25zGAIgASgJIoUBCgpTZW9BcnRpY2xlEg0KBXRpdGxlGAEgASgJEhgKEG1ldGFfZGVzY3JpcHRpb24YAiABKAkSDAoEc2x1ZxgDIAEoCRIRCglib2R5X2h0bWwYBCABKAkSDwoHa2V5d29yZBgFIAEoCRIcChRpbnRlcm5hbF9saW5rX2RvbWFpbhgGIAEoCSJBChJTZW9DaGVja2xpc3RSZXN1bHQSCgoCaWQYASABKAUSDgoGc3RhdHVzGAIgASgJEg8KB2NvbW1lbnQYAyABKAkipQEKGkdlbmVyYXRlU2VvQXJ0aWNsZVJlc3BvbnNlEg8KB3N1bW1hcnkYASABKAkSKQoHYXJ0aWNsZRgCIAEoCzIYLmFwaV9wcm90by52MS5TZW9BcnRpY2xlEjsKEWNoZWNrbGlzdF9yZXN1bHRzGAMgAygLMiAuYXBpX3Byb3RvLnYxLlNlb0NoZWNrbGlzdFJlc3VsdBIOCgZsb2dfaWQYBCABKAkiQAofTGlzdFNlb0dlbmVyYXRpb25IaXN0b3J5UmVxdWVzdBINCgVsaW1pdBgBIAEoBRIOCgZvZmZzZXQYAiABKAUiXwogTGlzdFNlb0dlbmVyYXRpb25IaXN0b3J5UmVzcG9uc2USLAoEbG9ncxgBIAMoCzIeLmFwaV9wcm90by52MS5TZW9HZW5lcmF0aW9uTG9nEg0KBXRvdGFsGAIgASgDIjAKHkdldFNlb0dlbmVyYXRpb25BcnRpY2xlUmVxdWVzdBIOCgZsb2dfaWQYASABKAkiiQEKH0dldFNlb0dlbmVyYXRpb25BcnRpY2xlUmVzcG9uc2USKQoHYXJ0aWNsZRgBIAEoCzIYLmFwaV9wcm90by52MS5TZW9BcnRpY2xlEjsKEWNoZWNrbGlzdF9yZXN1bHRzGAIgAygLMiAuYXBpX3Byb3RvLnYxLlNlb0NoZWNrbGlzdFJlc3VsdCLYAQoQU2VvR2VuZXJhdGlvbkxvZxIKCgJpZBgBIAEoCRISCgpjb21wYW55X2lkGAIgASgDEhgKEGNvbXBhbnlfc3RhZmZfaWQYAyABKAMSGgoSY29tcGFueV9zdGFmZl9uYW1lGAQgASgJEg8KB2tleXdvcmQYBSABKAkSDQoFdGl0bGUYBiABKAkSEQoJb3BlcmF0aW9uGAcgASgJEg4KBnN0YXR1cxgIIAEoCRIrCgdjcmVhdGVkGAkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIzWjFnaXRodWIuY29tL2gtc2NhcGUvaWVzYXB1cmkvZ28vYXBpX3Byb3RvL3YxO2FwaXYxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * SEO 記事の生成リクエスト
 *
 * @generated from message api_proto.v1.GenerateSeoArticleRequest
 */
export type GenerateSeoArticleRequest = Message<"api_proto.v1.GenerateSeoArticleRequest"> & {
  /**
   * ターゲットキーワード（必須）
   *
   * @generated from field: string keyword = 1;
   */
  keyword: string;

  /**
   * 文字数指定。"900~1000" / "2300~2500" / "4500~5000" のいずれか
   *
   * @generated from field: string word_count = 2;
   */
  wordCount: string;

  /**
   * 参考 URL（任意）
   *
   * @generated from field: repeated string reference_urls = 3;
   */
  referenceUrls: string[];

  /**
   * 内部リンク埋め込み用の自社ドメイン（任意）
   *
   * @generated from field: string internal_link_domain = 4;
   */
  internalLinkDomain: string;

  /**
   * 追加指示（任意）
   *
   * @generated from field: string instructions = 5;
   */
  instructions: string;
};

/**
 * Describes the message api_proto.v1.GenerateSeoArticleRequest.
 * Use `create(GenerateSeoArticleRequestSchema)` to create a new message.
 */
export const GenerateSeoArticleRequestSchema: GenMessage<GenerateSeoArticleRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_seo_writing, 0);

/**
 * 生成済み記事の修正リクエスト
 *
 * @generated from message api_proto.v1.ReviseSeoArticleRequest
 */
export type ReviseSeoArticleRequest = Message<"api_proto.v1.ReviseSeoArticleRequest"> & {
  /**
   * 修正対象の記事（直近の生成/編集結果）
   *
   * @generated from field: api_proto.v1.SeoArticle current = 1;
   */
  current?: SeoArticle;

  /**
   * 修正指示（必須）
   *
   * @generated from field: string revise_instructions = 2;
   */
  reviseInstructions: string;
};

/**
 * Describes the message api_proto.v1.ReviseSeoArticleRequest.
 * Use `create(ReviseSeoArticleRequestSchema)` to create a new message.
 */
export const ReviseSeoArticleRequestSchema: GenMessage<ReviseSeoArticleRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_seo_writing, 1);

/**
 * SEO 記事
 *
 * @generated from message api_proto.v1.SeoArticle
 */
export type SeoArticle = Message<"api_proto.v1.SeoArticle"> & {
  /**
   * タイトル（30-60 文字目安）
   *
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * メタディスクリプション（120-150 文字目安）
   *
   * @generated from field: string meta_description = 2;
   */
  metaDescription: string;

  /**
   * URL スラッグ（kebab-case）
   *
   * @generated from field: string slug = 3;
   */
  slug: string;

  /**
   * 記事本文 HTML（<h2> 始まり、<h1> 禁止）
   *
   * @generated from field: string body_html = 4;
   */
  bodyHtml: string;

  /**
   * 生成時のターゲットキーワード
   *
   * @generated from field: string keyword = 5;
   */
  keyword: string;

  /**
   * 生成時の内部リンクドメイン
   *
   * @generated from field: string internal_link_domain = 6;
   */
  internalLinkDomain: string;
};

/**
 * Describes the message api_proto.v1.SeoArticle.
 * Use `create(SeoArticleSchema)` to create a new message.
 */
export const SeoArticleSchema: GenMessage<SeoArticle> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_seo_writing, 2);

/**
 * SEO チェックリスト（13 項目固定）の自己評価結果
 *
 * @generated from message api_proto.v1.SeoChecklistResult
 */
export type SeoChecklistResult = Message<"api_proto.v1.SeoChecklistResult"> & {
  /**
   * チェック項目 ID（1-13。項目定義は FE 側 seoChecklist.ts と Go 側プロンプトで同一）
   *
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * "OK" / "改善が必要" / "要確認"
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * 判定理由
   *
   * @generated from field: string comment = 3;
   */
  comment: string;
};

/**
 * Describes the message api_proto.v1.SeoChecklistResult.
 * Use `create(SeoChecklistResultSchema)` to create a new message.
 */
export const SeoChecklistResultSchema: GenMessage<SeoChecklistResult> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_seo_writing, 3);

/**
 * 生成・修正の共通レスポンス
 *
 * @generated from message api_proto.v1.GenerateSeoArticleResponse
 */
export type GenerateSeoArticleResponse = Message<"api_proto.v1.GenerateSeoArticleResponse"> & {
  /**
   * 作成内容の簡潔な要約
   *
   * @generated from field: string summary = 1;
   */
  summary: string;

  /**
   * @generated from field: api_proto.v1.SeoArticle article = 2;
   */
  article?: SeoArticle;

  /**
   * @generated from field: repeated api_proto.v1.SeoChecklistResult checklist_results = 3;
   */
  checklistResults: SeoChecklistResult[];

  /**
   * ai_seo_generation_logs.id（ULID、履歴一覧用）
   *
   * @generated from field: string log_id = 4;
   */
  logId: string;
};

/**
 * Describes the message api_proto.v1.GenerateSeoArticleResponse.
 * Use `create(GenerateSeoArticleResponseSchema)` to create a new message.
 */
export const GenerateSeoArticleResponseSchema: GenMessage<GenerateSeoArticleResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_seo_writing, 4);

/**
 * 生成履歴一覧
 *
 * @generated from message api_proto.v1.ListSeoGenerationHistoryRequest
 */
export type ListSeoGenerationHistoryRequest = Message<"api_proto.v1.ListSeoGenerationHistoryRequest"> & {
  /**
   * 取得件数（0 はデフォルト 20）
   *
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 2;
   */
  offset: number;
};

/**
 * Describes the message api_proto.v1.ListSeoGenerationHistoryRequest.
 * Use `create(ListSeoGenerationHistoryRequestSchema)` to create a new message.
 */
export const ListSeoGenerationHistoryRequestSchema: GenMessage<ListSeoGenerationHistoryRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_seo_writing, 5);

/**
 * @generated from message api_proto.v1.ListSeoGenerationHistoryResponse
 */
export type ListSeoGenerationHistoryResponse = Message<"api_proto.v1.ListSeoGenerationHistoryResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.SeoGenerationLog logs = 1;
   */
  logs: SeoGenerationLog[];

  /**
   * 総件数（ページネーション用）
   *
   * @generated from field: int64 total = 2;
   */
  total: bigint;
};

/**
 * Describes the message api_proto.v1.ListSeoGenerationHistoryResponse.
 * Use `create(ListSeoGenerationHistoryResponseSchema)` to create a new message.
 */
export const ListSeoGenerationHistoryResponseSchema: GenMessage<ListSeoGenerationHistoryResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_seo_writing, 6);

/**
 * 生成履歴からの編集再開: 指定ログの保存済み記事を取得
 *
 * @generated from message api_proto.v1.GetSeoGenerationArticleRequest
 */
export type GetSeoGenerationArticleRequest = Message<"api_proto.v1.GetSeoGenerationArticleRequest"> & {
  /**
   * ai_seo_generation_logs.id（ULID）。success かつ output を持つログのみ対象
   *
   * @generated from field: string log_id = 1;
   */
  logId: string;
};

/**
 * Describes the message api_proto.v1.GetSeoGenerationArticleRequest.
 * Use `create(GetSeoGenerationArticleRequestSchema)` to create a new message.
 */
export const GetSeoGenerationArticleRequestSchema: GenMessage<GetSeoGenerationArticleRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_seo_writing, 7);

/**
 * @generated from message api_proto.v1.GetSeoGenerationArticleResponse
 */
export type GetSeoGenerationArticleResponse = Message<"api_proto.v1.GetSeoGenerationArticleResponse"> & {
  /**
   * 保存済みの生成/修正結果（編集再開用）
   *
   * @generated from field: api_proto.v1.SeoArticle article = 1;
   */
  article?: SeoArticle;

  /**
   * @generated from field: repeated api_proto.v1.SeoChecklistResult checklist_results = 2;
   */
  checklistResults: SeoChecklistResult[];
};

/**
 * Describes the message api_proto.v1.GetSeoGenerationArticleResponse.
 * Use `create(GetSeoGenerationArticleResponseSchema)` to create a new message.
 */
export const GetSeoGenerationArticleResponseSchema: GenMessage<GetSeoGenerationArticleResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_seo_writing, 8);

/**
 * 生成履歴 1 件（一覧表示用のサマリ。本文 HTML は含めない）
 *
 * @generated from message api_proto.v1.SeoGenerationLog
 */
export type SeoGenerationLog = Message<"api_proto.v1.SeoGenerationLog"> & {
  /**
   * ai_seo_generation_logs.id（ULID）
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 company_id = 2;
   */
  companyId: bigint;

  /**
   * 実行担当
   *
   * @generated from field: int64 company_staff_id = 3;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: string company_staff_name = 4;
   */
  companyStaffName: string;

  /**
   * 入力キーワード
   *
   * @generated from field: string keyword = 5;
   */
  keyword: string;

  /**
   * 出力記事タイトル
   *
   * @generated from field: string title = 6;
   */
  title: string;

  /**
   * "generate" / "revise"
   *
   * @generated from field: string operation = 7;
   */
  operation: string;

  /**
   * "success" / "error"
   *
   * @generated from field: string status = 8;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Timestamp created = 9;
   */
  created?: Timestamp;
};

/**
 * Describes the message api_proto.v1.SeoGenerationLog.
 * Use `create(SeoGenerationLogSchema)` to create a new message.
 */
export const SeoGenerationLogSchema: GenMessage<SeoGenerationLog> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_seo_writing, 9);

